export const BACKGROUND_IMAGES = [
  {
    url: "/banner1.avif",
    title: "Advanced Medical Technology",
    subtitle: "State-of-the-art equipment for precise diagnosis"
  },
  {
    url: "/banner2.avif",
    title: "Expert Medical Team",
    subtitle: "Experienced professionals dedicated to your health"
  },
  {
    url: "/banner3.avif",
    title: "Comprehensive Patient Care",
    subtitle: "Personalized treatment plans for every patient"
  }
];
